export enum UserRole {
  MASTER = 0,
  PROGRAMMER = 1,
  SELLER = 2,
  PARTNER = 3,
}

export const UserRoleLabels = {
  [UserRole.MASTER]: 'Master',
  [UserRole.PROGRAMMER]: 'Programador',
  [UserRole.SELLER]: 'Vendedor',
  [UserRole.PARTNER]: 'Partner',
} as const;

export const UserRoleColors = {
  [UserRole.MASTER]: 'bg-red-100 text-red-800',
  [UserRole.PROGRAMMER]: 'bg-blue-100 text-blue-800',
  [UserRole.SELLER]: 'bg-green-100 text-green-800',
  [UserRole.PARTNER]: 'bg-purple-100 text-purple-800',
} as const;

export type UserRoleType = keyof typeof UserRole;

// Función helper para obtener el label del rol
export const getUserRoleLabel = (role: UserRole | number | null | undefined): string => {
  if (role === null || role === undefined) return 'Sin rol';
  return UserRoleLabels[role as UserRole] || 'Desconocido';
};

// Función helper para verificar si un usuario tiene un rol específico
export const hasUserRole = (userRole: UserRole | number | null | undefined, requiredRole: UserRole): boolean => {
  return userRole === requiredRole;
};

// Función helper para verificar si un usuario tiene uno de varios roles
export const hasAnyUserRole = (userRole: UserRole | number | null | undefined, allowedRoles: UserRole[]): boolean => {
  return allowedRoles.includes(userRole as UserRole);
}; 